module.exports = __webpack_public_path__ + "dataanalysestatic/fonts/iconfont.8ea0210.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.ttf?t=1645583797398
// module id = RfX2
// module chunks = 37